module.exports = __webpack_public_path__ + "static/media/cssImg.c26a73b4.png";